<template>
  <div class="categories-container cl-root">
    <div class="navigation-panel">
      <button v-if="showHideEmptyToggle"
              type="button"
              :class="{'is-on': hideEmptyCategories}"
              :aria-pressed="hideEmptyCategories ? 'true' : 'false'"
              @click="toggleHideEmptyCategories"
              class="adm-btn adm-btn-sm checkbox-list-button">
        <span class="cl-toggle-box" aria-hidden="true"><tkd-icon v-if="hideEmptyCategories" name="check"/></span>
        Сховати пусті категорії
      </button>
      <slot name="navigation-actions"></slot>
    </div>

    <div class="adm-filter-grid category-filters-row">
      <div class="adm-field">
        <label class="adm-label">Пошук</label>
        <input v-model="searchQuery"
               type="search"
               class="adm-input"
               placeholder="Назва, вік, стать, тип..." />
      </div>
      <div class="adm-field">
        <label class="adm-label">Клас</label>
        <v-select label="name" :filterable="true" :options="filterClassOptions" v-model="filterClassVal">
          <template slot="no-options">Укажіть клас</template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              <span class="name-city">{{ option.name }}</span>
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              <span class="name-city">{{ option.name }}</span>
            </div>
          </template>
        </v-select>
      </div>
      <div class="adm-field">
        <label class="adm-label">Тип пумсе</label>
        <v-select label="name" :filterable="true" :options="filterPoomsaeTypeOptions" v-model="filterPoomsaeTypeVal">
          <template slot="no-options">Укажіть тип пумсе</template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              <span class="name-city">{{ option.name }}</span>
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              <span class="name-city">{{ option.name }}</span>
            </div>
          </template>
        </v-select>
      </div>
    </div>

    <div class="cl-title-row">
      <h4 class="cl-title">{{ title }} <span class="adm-count">{{ filteredCategories.length }}</span></h4>
      <label class="bulk-checkbox-label" v-if="showSelectAll && filteredCategories.length">
        <input type="checkbox"
               :checked="allSelected"
               @change="$emit('toggle-all', $event.target.checked)">
        <span>Всі</span>
      </label>
    </div>

    <div :id="listId" class="category_list_drawing_wrapper" :style="{ gridTemplateColumns: wrapperColumns }">
      <div class="category_list_drawing" :style="{ gridTemplateColumns: listColumns }" v-if="maleFilteredCategories.length">
        <div class="cl-group-title">Чоловіки <span>{{ maleFilteredCategories.length }}</span></div>
        <div v-for="item in maleFilteredCategories"
             :key="'male_'+item.id"
             class="category-item man-category"
             :class="[itemClass, {'bg-info': highlightSelected && String(selectedId) === String(item.id), 'is-empty': getCategoryCount(item) == 0, 'is-picked': isPicked(item)}]"
             style="cursor: pointer"
             :draggable="draggableItems ? 'true' : null"
             @dragstart="draggableItems && $emit('item-dragstart', item, $event)"
             @dragend="draggableItems && $emit('item-dragend', item, $event)"
             @click="$emit('item-click', item)">
          <slot name="item-overlay" :item="item"></slot>
          <div class="category-item-inner">
            <div class="category-item-side">
              <span class="category-count-sportsmans">{{ getCategoryCount(item) }}</span>
            </div>
            <div class="category-item-main">
              <slot name="item-main-prefix" :item="item"></slot>
              <span class="category-item-name">{{ item.fullname || item.name }}</span>
            </div>
          </div>
          <div v-if="hasItemFooter" class="category-item-extra">
            <slot name="item-footer" :item="item"></slot>
          </div>
        </div>
      </div>

      <div class="category_list_drawing" :style="{ gridTemplateColumns: listColumns }" v-if="femaleFilteredCategories.length">
        <div class="cl-group-title">Жінки <span>{{ femaleFilteredCategories.length }}</span></div>
        <div v-for="item in femaleFilteredCategories"
             :key="'female_'+item.id"
             class="category-item woman-category"
             :class="[itemClass, {'bg-info': highlightSelected && String(selectedId) === String(item.id), 'is-empty': getCategoryCount(item) == 0, 'is-picked': isPicked(item)}]"
             style="cursor: pointer"
             :draggable="draggableItems ? 'true' : null"
             @dragstart="draggableItems && $emit('item-dragstart', item, $event)"
             @dragend="draggableItems && $emit('item-dragend', item, $event)"
             @click="$emit('item-click', item)">
          <slot name="item-overlay" :item="item"></slot>
          <div class="category-item-inner">
            <div class="category-item-side">
              <span class="category-count-sportsmans">{{ getCategoryCount(item) }}</span>
            </div>
            <div class="category-item-main">
              <slot name="item-main-prefix" :item="item"></slot>
              <span class="category-item-name">{{ item.fullname || item.name }}</span>
            </div>
          </div>
          <div v-if="hasItemFooter" class="category-item-extra">
            <slot name="item-footer" :item="item"></slot>
          </div>
        </div>
      </div>

      <div class="category_list_drawing" :style="{ gridTemplateColumns: listColumns }" v-if="otherFilteredCategories.length">
        <div class="cl-group-title">Змішані / інші <span>{{ otherFilteredCategories.length }}</span></div>
        <div v-for="item in otherFilteredCategories"
             :key="'other_'+item.id"
             class="category-item other-category"
             :class="[itemClass, {'bg-info': highlightSelected && String(selectedId) === String(item.id), 'is-empty': getCategoryCount(item) == 0, 'is-picked': isPicked(item)}]"
             style="cursor: pointer"
             :draggable="draggableItems ? 'true' : null"
             @dragstart="draggableItems && $emit('item-dragstart', item, $event)"
             @dragend="draggableItems && $emit('item-dragend', item, $event)"
             @click="$emit('item-click', item)">
          <slot name="item-overlay" :item="item"></slot>
          <div class="category-item-inner">
            <div class="category-item-side">
              <span class="category-count-sportsmans">{{ getCategoryCount(item) }}</span>
            </div>
            <div class="category-item-main">
              <slot name="item-main-prefix" :item="item"></slot>
              <span class="category-item-name">{{ item.fullname || item.name }}</span>
            </div>
          </div>
          <div v-if="hasItemFooter" class="category-item-extra">
            <slot name="item-footer" :item="item"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'src/assets/css/tkd-theme.css';
import 'src/assets/css/tkd-admin.css';

export default {
  name: 'TournamentCategoryList',
  props: {
    categories: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: 'Всі категорії',
    },
    selectedId: {
      type: [Number, String],
      default: null,
    },
    listId: {
      type: String,
      default: 'category_list_drawing',
    },
    itemClass: {
      type: String,
      default: '',
    },
    wrapperColumns: {
      type: String,
      default: 'repeat(2, minmax(0, 1fr))',
    },
    listColumns: {
      type: String,
      default: 'repeat(2, minmax(0, 1fr))',
    },
    allSelected: {
      type: Boolean,
      default: false,
    },
    showSelectAll: {
      type: Boolean,
      default: false,
    },
    showHideEmptyToggle: {
      type: Boolean,
      default: true,
    },
    highlightSelected: {
      type: Boolean,
      default: true,
    },
    // id вибраних (позначених) категорій — підсвічуються
    pickedIds: {
      type: Array,
      default: () => [],
    },
    // дозволити перетягування карток (HTML5 drag & drop)
    draggableItems: {
      type: Boolean,
      default: false,
    },
    // "Сховати пусті категорії" увімкнено одразу
    hideEmptyDefault: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchQuery: '',
      filterClassVal: null,
      filterPoomsaeTypeVal: null,
      hideEmptyCategories: this.hideEmptyDefault,
    };
  },
  computed: {
    filterClassOptions() {
      const classOptions = [];

      this.filteredCategories.forEach(protocol => {
        const categoryClass = this.extractCategoryClass(protocol);
        if (categoryClass && !classOptions.includes(categoryClass)) {
          classOptions.push(categoryClass);
        }
      });

      return classOptions.map(option => ({ name: option, value: option }));
    },
    filterPoomsaeTypeOptions() {
      const typeOptions = [];

      this.filteredCategories.forEach(protocol => {
        const poomsaeType = this.extractPoomsaeType(protocol);
        if (poomsaeType && !typeOptions.find(option => option.value === poomsaeType.value)) {
          typeOptions.push(poomsaeType);
        }
      });

      return typeOptions;
    },
    filteredCategories() {
      let protocols = this.categories.slice();

      if (this.hideEmptyCategories) {
        // обрану категорію не ховаємо, навіть якщо вона порожня
        protocols = protocols.filter(item => this.getCategoryCount(item) > 0 || String(item.id) === String(this.selectedId));
      }

      if (this.searchQuery && this.searchQuery.trim()) {
        const searchQuery = this.searchQuery.trim().toLowerCase();
        protocols = protocols.filter(item => this.getCategorySearchText(item).includes(searchQuery));
      }

      if (this.filterClassVal) {
        protocols = protocols.filter(item => this.extractCategoryClass(item) === this.filterClassVal.value);
      }

      if (this.filterPoomsaeTypeVal) {
        protocols = protocols.filter(item => {
          const poomsaeType = this.extractPoomsaeType(item);
          return poomsaeType && poomsaeType.value === this.filterPoomsaeTypeVal.value;
        });
      }

      return protocols;
    },
    maleFilteredCategories() {
      return this.filteredCategories.filter(item => String(item.sex) === '1');
    },
    femaleFilteredCategories() {
      return this.filteredCategories.filter(item => String(item.sex) === '2');
    },
    otherFilteredCategories() {
      return this.filteredCategories.filter(item => String(item.sex) !== '1' && String(item.sex) !== '2');
    },
    hasItemFooter() {
      return Boolean(this.$scopedSlots['item-footer'] || this.$slots['item-footer']);
    },
  },
  watch: {
    filteredCategories: {
      immediate: true,
      handler(value) {
        this.$emit('filtered-change', value);
      },
    },
  },
  methods: {
    isPicked(item) {
      return this.pickedIds.some(id => String(id) === String(item.id));
    },
    toggleHideEmptyCategories() {
      this.hideEmptyCategories = !this.hideEmptyCategories;
    },
    getCategoryCount(category) {
      return category.count_sportsmans || category.count || 0;
    },
    getCategorySearchText(category) {
      const fullName = category?.fullname || category?.name || '';
      const sexLabel = String(category?.sex) === '1'
        ? 'чоловік'
        : (String(category?.sex) === '2' ? 'жінка' : '');
      const typeLabel = String(category?.type) === '1'
        ? 'керугі'
        : (String(category?.type) === '2' ? 'пумсе' : '');
      const showTypeLabel = String(category?.show_type) === '1'
        ? 'сітка'
        : (String(category?.show_type) === '2' ? 'список' : '');
      const classLabel = this.extractCategoryClass(category) || '';
      const poomsaeType = this.extractPoomsaeType(category);

      return [
        fullName,
        category?.age_category || '',
        sexLabel,
        typeLabel,
        showTypeLabel,
        classLabel,
        poomsaeType ? poomsaeType.name : '',
        category?.id || '',
        this.getCategoryCount(category)
      ].join(' ').toLowerCase();
    },
    extractCategoryClass(category) {
      const fullName = category?.fullname || category?.name || '';
      const match = fullName.match(/^Клас\s+([АБС])/i);
      return match ? match[1].toUpperCase() : null;
    },
    extractPoomsaeType(category) {
      const fullName = category?.fullname || category?.name || '';
      if (fullName.includes('Традиційні пумсе')) {
        return { name: 'Традиційні', value: 'traditional' };
      }
      if (fullName.includes('Вільні пумсе')) {
        return { name: 'Вільні', value: 'freestyle' };
      }
      return null;
    },
  },
}
</script>

<style lang="scss" scoped>
/* Нейтральний список категорій: стать — лише тонка смужка, вибрана — темна */
.cl-root { font-family: var(--tkd-font); color: var(--tkd-text); }

.draft-status-badge {
  display: inline-block;
  margin-right: 5px;
  vertical-align: middle;

  i {
    font-size: 14px;
    font-weight: bold;
  }
}

.bulk-checkbox-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  text-transform: none;
  color: var(--tkd-text);
}

.navigation-panel {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}

.cl-toggle-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border: 1.5px solid currentColor;
  border-radius: 4px;
  font-size: 11px;
  line-height: 1;
}

.category-filters-row { margin-bottom: 16px; }

.cl-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}

.cl-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  font-size: 18px;
  font-weight: 800;
  color: var(--tkd-text);
}

.category_list_drawing_wrapper {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px 20px;
  margin-bottom: 8px;
}

.category_list_drawing {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-gap: 8px;
  align-content: start;

  .cl-group-title {
    grid-column: 1 / -1;
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    color: var(--tkd-muted);

    span {
      padding: 0 7px;
      border-radius: 999px;
      background: var(--tkd-bg);
      border: 1px solid var(--tkd-border);
      font-size: 11px;
    }
  }

  .category-item {
    position: relative;
    padding: 0;
    overflow: hidden;
    border: 1px solid var(--tkd-border);
    border-left-width: 3px;
    border-radius: 10px;
    background: var(--tkd-surface);
    transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
  }

  .category-item:hover {
    border-color: var(--tkd-muted);
    box-shadow: 0 4px 12px rgba(10, 31, 68, 0.08);
  }

  .category-item-inner {
    display: grid;
    grid-template-columns: 48px 1fr;
    min-height: 100%;
  }

  .category-item-side {
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid var(--tkd-border);
    background: var(--tkd-bg);
    font-weight: 800;
    color: var(--tkd-text);
  }

  .category-item-main {
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
    padding: 8px 10px;
    font-size: 14px;
  }

  .category-item-name {
    display: inline-block;
    min-width: 0;
    overflow-wrap: anywhere;
  }

  .category-item-extra {
    padding: 0 10px 10px;
  }

  /* стать — нейтральні відтінки смужки зліва */
  .category-item.man-category { border-left-color: #475467; }
  .category-item.woman-category { border-left-color: #98a2b3; }
  .category-item.other-category { border-left-color: #d0d5dd; }

  /* позначені (вибрані) категорії */
  .category-item.is-picked {
    border-color: var(--tkd-navy);
    background: #eef1f6;
    box-shadow: 0 0 0 1px var(--tkd-navy);
  }

  .category-item.is-picked .category-item-side { background: var(--tkd-navy); color: #fff; }

  .category-item[draggable="true"] { cursor: grab !important; }
  .category-item[draggable="true"]:active { cursor: grabbing !important; }

  /* порожні категорії — приглушено */
  .category-item.is-empty .category-item-main { color: var(--tkd-muted); }
  .category-item.is-empty .category-item-side { color: var(--tkd-muted); font-weight: 600; }

  .category-item.bg-info {
    border-color: var(--tkd-navy) !important;
    background: var(--tkd-navy) !important;
    box-shadow: 0 6px 16px rgba(10, 31, 68, 0.25);

    .category-item-side {
      border-right-color: rgba(255, 255, 255, 0.15);
      background: var(--tkd-navy-dark) !important;
      color: #fff;
    }

    .category-item-main {
      color: #fff;
    }
  }

  .category-count-sportsmans {
    width: 100%;
    padding: 9px 4px;
    font-size: 13px;
    line-height: 1;
    text-align: center;
    font-variant-numeric: tabular-nums;
  }
}

@media (max-width: 767px) {
  .category_list_drawing_wrapper,
  .category_list_drawing { grid-template-columns: minmax(0, 1fr) !important; }
}

@media (prefers-reduced-motion: reduce) {
  .category_list_drawing .category-item { transition: none; }
}
</style>
